import React from 'react';

class Linkr extends React.Component {
	render(){
		return (<a src={this.props.to} onClick={(e) => {
			e.preventDefault();
			this.props.history.push(this.props.to);
			if(this.props.onClick)
			{
				this.props.onClick();
			}
		}}>{this.props.children}</a>);
	}
}

export default Linkr;


// WEBPACK FOOTER //
// ./src/components/Linkr.js